import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import App from 'common/backbone-app';
import { stripeInstanceSelector } from '../selectors';
import { withStripe as withStripeHoC } from './withStripe';
import { Stripe } from '@stripe/stripe-js';

export interface InjectedProps {
  stripe: Stripe | null;
  stripePublicApiKey: string;
  supplierId: string;
  idealPaymentInProgress: boolean;
}
const mapStateToProps = (state) => {
  return {
    stripe: stripeInstanceSelector(state, {
      locale: App.getClientLocale(),
    }),
    stripePublicApiKey: state.stripe.stripePublicApiKey,
    supplierId: App.config.get('venue').supplierId,
    idealPaymentInProgress: state.stripe.idealPaymentInProgress,
  };
};

type hocType = <T>(
  c: React.ComponentType<T>,
) => React.ComponentType<Pick<T, Exclude<keyof T, keyof InjectedProps>>>;

export const withStripe = (compose(connect(mapStateToProps), withStripeHoC) as unknown) as hocType;
